const { isAuthenticated } = storeToRefs(useUserStore())

export default defineNuxtRouteMiddleware(async () => {
  if (!isAuthenticated.value) {
    return navigateTo('/login')
  }
})
